var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_c('span',[_vm._v(_vm._s(_vm.copyright))]),_c('a',{attrs:{"href":"http://goatsuccess.com/"}},[_vm._v(" goatsuccess.com")])])}
var staticRenderFns = []

export { render, staticRenderFns }